// Returns the raw response without JSON parsing
export function rawResponse(data) {
  const response = {
    data: data,
  };
  return response;
}
